import axios from 'axios';

// TODO use maybeReportExceptionInterceptor once maybeReportException is shared

export default axios.create();
